<template>
  <div v-if="estAuthentifeAvecUnContexte">
    <div
      ref="notifications"
      class="notifications__trigger"
    >
      <slot
        name="trigger-notification"
        :toggleNotifications
        :showNotifications
        :hasNotifications="store.unreadNotificationsList?.data.length"
      />
    </div>
    <component
      v-if="showNotifications"
      :is="isMobile ? Teleport : 'div'"
      :to="isMobile ? 'body' : undefined"
    >
      <NotificationPanel
        ref="modalPanelRef"
        :listToggleId
        :unreadList="store.unreadNotificationsList"
        :allList="store.allNotificationsList"
        :mode="isMobile ? 'mobile' : 'desktop'"
        @update:listToggleId="(v) => (listToggleId = v)"
        @markAllAs="markAllAs"
        @changeNotificationStatut="changeNotificationStatut"
      />
    </component>
  </div>
</template>

<script setup lang="ts">
  import { computed, inject, ref, Teleport, useTemplateRef } from 'vue'
  import { useAppStateStore } from '@/features/application'
  import { useNotificationsStore } from './useNotificationsStore'
  import { useDialog } from '@/features/interface/dialog'
  import { useHandleClickOutside } from '@/features/interface/composables/useHandleClickOutside'
  import type { NotificationStatutDTO } from '@/features/api/extranet/dto/Notification/NotificationStatutDTO'
  import type { NotificationPayloadDTO } from '@/features/api/extranet/dto/Notification/NotificationPayloadDTO'
  import NotificationPanel from './NotificationPanel.vue'
  import { DEVICE_BREAKPOINT} from '@/plugin/device-breakpoint'

  import { storeToRefs } from 'pinia'

  const { isMobile } = inject(DEVICE_BREAKPOINT)!

  const { estAuthentifeAvecUnContexte } = storeToRefs(useAppStateStore())
  const showNotifications = defineModel<boolean>()

  const dialog = useDialog()
  const listToggleId = ref(0)
  const notifications = ref<HTMLElement | null>(null)

  const store = useNotificationsStore()

  function toggleNotifications() {
    showNotifications.value = !showNotifications.value
  }

  const markAllAs = async (statut: NotificationStatutDTO) => {
    pauseClickOutside(async () => {
      const result = await dialog.showDialog({
        message: statut === 'Read' ? 'Voulez-vous tout marquer comme lu ?' : 'Voulez-vous tout marquer comme non-lu ?',
        type: 'YesNo',
        title: statut === 'Read' ? 'Tout marquer comme lu' : 'Tout marquer comme non-lu',
      })
      if (result === 'Yes') {
        store.markAllNotificationsAs(statut)
      }
    })
  }

  const getModalPanelDom = useTemplateRef('modalPanelRef')

  const modalPanel = computed(() => getModalPanelDom.value?.$el ?? null)

  const changeNotificationStatut = async (id: number, statut: NotificationStatutDTO) => {
    const payload = {
      IdsNotification: [id],
      StatutTo: statut,
      statutsFrom: statut === 'Read' ? ['Unread'] : ['Read'],
    } as NotificationPayloadDTO

    store.changeSingleNotificationStatus(payload)
  }

  const { pauseClickOutside } = useHandleClickOutside([modalPanel, notifications], () => {
    showNotifications.value = false
  })
</script>
<style lang="less" scoped>
  @import './NotificationsComponent.less';
</style>
